import { Button } from 'antd';
import { Link } from 'react-router';
import Line from '../line';
import styles from './403.module.css';

const Error403 = () => {
  return (
    <div className={styles.container}>
      <Line />
      <div className={styles.content}>
        <h1 className="hp-error-content-title hp-font-weight-300 hp-text-color-black-bg hp-text-color-dark-0 hp-mb-0">
          403
        </h1>
        <h2 className="h1 hp-mb-16">Forbidden</h2>
        <p className="hp-mb-32 hp-p1-body hp-text-color-black-100 hp-text-color-dark-0">
          You don’t have an access to this page.
        </p>
        <Link to="../">
          <Button type="primary">Back to Home</Button>
        </Link>
      </div>
    </div>
  );
};

export default Error403;
